import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';
import { ToastContainerComponent } from '@shared/components/toast/toast-container.component';

@Component({
  selector: 'mtm-root',
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  readonly title = 'platform-admin-ui';

  // Instantiated at startup so the theme follows the OS live in `system` mode, on every page.
  private readonly theme = inject(ThemeService);
}
